<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 16 16">
    <g transform="translate(9192 8091)">
      <g transform="translate(-9190 -8089.667)">
        <path d="M128,134.649s5.714-1.9,5.714-6.667" transform="translate(-122.286 -121.315)" fill="none" stroke="#7b8190" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
        <path d="M133.714,22.666V16.952A13.824,13.824,0,0,0,128,16" transform="translate(-122.286 -16)" fill="none" stroke="#7b8190" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
        <path d="M37.729,134.649s-5.714-1.9-5.714-6.667" transform="translate(-32.015 -121.315)" fill="none" stroke="#7b8190" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
        <path d="M32.015,22.666V16.952A13.824,13.824,0,0,1,37.729,16" transform="translate(-32.015 -16)" fill="none" stroke="#7b8190" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
        <path d="M86.674,63.992a13.241,13.241,0,0,0-4.762,6.667,16.455,16.455,0,0,0-1.9-1.9" transform="translate(-77.15 -61.135)" fill="none" stroke="#7b8190" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :style="{ fill: 'none !important' }" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconXmark',

  props: {
    size: { type: [String, Number], default: '16px' },
    // colorFill: { type: String, default: '#7b8190' },
  }
}
</script>